export default function Contact() {
  return (
    <section className="py-20 px-6 max-w-xl mx-auto">
      <h2 className="text-4xl font-bold mb-8 text-center text-[#2D033B]">
        Contact Us
      </h2>

      <form className="space-y-6">
        <input
          className="w-full border border-[#E5D9F2] p-3 rounded focus:ring-2 focus:ring-[#6A0DAD] transition"
          placeholder="Your Name"
        />
        <input
          type="email"
          className="w-full border border-[#E5D9F2] p-3 rounded focus:ring-2 focus:ring-[#6A0DAD] transition"
          placeholder="Email"
        />
        <textarea
          className="w-full border border-[#E5D9F2] p-3 rounded focus:ring-2 focus:ring-[#6A0DAD] transition"
          placeholder="Message"
          rows={5}
        />
        <button className="bg-[#6A0DAD] text-white px-6 py-3 rounded text-lg font-semibold transition hover:bg-[#5F0F99]">
          Send Message
        </button>
      </form>
    </section>
  );
}
